var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloneProduct({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.39844 7.59752C4.39844 5.78019 4.39844 4.87152 4.96044 4.30685C5.5231 3.74219 6.42777 3.74219 8.23844 3.74219H10.1584C11.9684 3.74219 12.8738 3.74219 13.4358 4.30685C13.9984 4.87152 13.9984 5.78019 13.9984 7.59752V10.8109C13.9984 12.6282 13.9984 13.5369 13.4358 14.1015C12.8738 14.6662 11.9684 14.6662 10.1584 14.6662H8.23844C6.42777 14.6662 5.5231 14.6662 4.96044 14.1015C4.39777 13.5369 4.39844 12.6282 4.39844 10.8109V7.59752Z",
    fill: "#2246DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2.78133 2.11336C2 2.89403 2 4.15136 2 6.66536V7.9987C2 10.5127 2 11.77 2.78133 12.5507C3.19267 12.9627 3.73667 13.1574 4.528 13.2494C4.4 12.6894 4.4 11.9187 4.4 10.8094V7.5967C4.4 5.77936 4.4 4.8707 4.962 4.30603C5.52467 3.74136 6.42933 3.74136 8.24 3.74136H10.16C11.2613 3.74136 12.0267 3.74136 12.5853 3.86803C12.4933 3.0727 12.2987 2.5267 11.8853 2.11336C11.1047 1.33203 9.84733 1.33203 7.33333 1.33203C4.81933 1.33203 3.562 1.33203 2.78133 2.11336Z",
    fill: "#2246DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloneProduct);
export default __webpack_public_path__ + "static/media/clone-product.20ac7e9223c58cd1fdbb84bb41adf7d5.svg";
export { ForwardRef as ReactComponent };